import { c as _c } from "react/compiler-runtime";
import { InlineRetry, ListError, ListMessage } from "./subcomponents/XtdhTokensFallbacks";
import { XtdhTokenListItem } from "./subcomponents/XtdhTokenListItem";
import { XtdhTokensSkeleton } from "./subcomponents/XtdhTokensSkeleton";
import { getTokenKey } from "./utils/getTokenKey";
import { useXtdhTokensListState } from "./hooks/useXtdhTokensListState";
import { useXtdhTokenMetadataMap } from "./useXtdhTokenMetadataMap";
import type { XtdhTokensListProps } from "./types";
export function XtdhTokensList(t0) {
  const $ = _c(31);
  const {
    tokens,
    contractAddress,
    isEnabled,
    isLoading,
    isError,
    errorMessage,
    onRetry,
    onTokenSelect
  } = t0;
  const {
    metadataMap,
    isFetching: isFetchingMetadata,
    hasError: hasMetadataError
  } = useXtdhTokenMetadataMap(contractAddress, tokens);
  let t1;
  if ($[0] !== isEnabled || $[1] !== isError || $[2] !== isLoading || $[3] !== tokens) {
    t1 = {
      tokens,
      isEnabled,
      isLoading,
      isError
    };
    $[0] = isEnabled;
    $[1] = isError;
    $[2] = isLoading;
    $[3] = tokens;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    isDisabled,
    showInitialLoading,
    showInitialError,
    showEmptyState
  } = useXtdhTokensListState(t1);
  if (isDisabled) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ListMessage>Unable to load token details for this collection.</ListMessage>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (showInitialLoading) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <XtdhTokensSkeleton />;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (showInitialError) {
    let t2;
    if ($[7] !== errorMessage || $[8] !== onRetry) {
      t2 = <ListError message={errorMessage} onRetry={onRetry} />;
      $[7] = errorMessage;
      $[8] = onRetry;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  if (showEmptyState) {
    let t2;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ListMessage>No individual token allocations were returned for this collection.</ListMessage>;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    return t2;
  }
  let t2;
  if ($[11] !== hasMetadataError || $[12] !== isFetchingMetadata || $[13] !== metadataMap || $[14] !== onTokenSelect || $[15] !== tokens) {
    let t3;
    if ($[17] !== hasMetadataError || $[18] !== isFetchingMetadata || $[19] !== metadataMap || $[20] !== onTokenSelect) {
      t3 = token => {
        const decimalId = Number.isFinite(token.token) ? Math.trunc(token.token).toString() : "";
        const metadata = decimalId ? metadataMap.get(decimalId) : undefined;
        const isMetadataLoading = !!decimalId && !metadata && isFetchingMetadata;
        const metadataError = !!decimalId && !metadata && hasMetadataError;
        const handleSelect = () => {
          onTokenSelect?.({
            token,
            metadata,
            isMetadataLoading,
            hasMetadataError: metadataError
          });
        };
        return <XtdhTokenListItem key={getTokenKey(token)} token={token} metadata={metadata} isMetadataLoading={isMetadataLoading} hasMetadataError={metadataError} onSelect={handleSelect} />;
      };
      $[17] = hasMetadataError;
      $[18] = isFetchingMetadata;
      $[19] = metadataMap;
      $[20] = onTokenSelect;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    t2 = tokens.map(t3);
    $[11] = hasMetadataError;
    $[12] = isFetchingMetadata;
    $[13] = metadataMap;
    $[14] = onTokenSelect;
    $[15] = tokens;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[22] !== t2) {
    t3 = <ul className="tw-m-0 tw-flex tw-flex-col tw-gap-3 tw-p-0">{t2}</ul>;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== errorMessage || $[25] !== isError || $[26] !== onRetry) {
    t4 = isError ? <InlineRetry message={errorMessage} onRetry={onRetry} /> : null;
    $[24] = errorMessage;
    $[25] = isError;
    $[26] = onRetry;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] !== t3 || $[29] !== t4) {
    t5 = <div className="tw-space-y-3">{t3}{t4}</div>;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
}